import type { RefObject } from 'react'
import { useEffect, useState } from 'react'

export function useMutationObserver<T extends Node>(
  ref: RefObject<T>,
  options: MutationObserverInit,
) {
  const [mutations, setMutations] = useState<MutationRecord[]>()

  useEffect(() => {
    if (!ref.current || typeof MutationObserver !== 'function') {
      return () => {}
    }

    const handler = (mutations: MutationRecord[]) => setMutations(mutations)
    const observer = new MutationObserver(handler)
    observer.observe(ref.current, options)

    return () => {
      setMutations(undefined)
      observer.disconnect()
    }
  }, [ref, options])

  return mutations
}
